import { render, staticRenderFns } from "./MySitesSelector.vue?vue&type=template&id=f6c0793a&"
import script from "./MySitesSelector.vue?vue&type=script&lang=js&"
export * from "./MySitesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports